/* Tile Touch — Find Your Tile Style quiz.
   Reads a spec (JSON in [data-quiz-spec]), renders a visual multi-step quiz, scores an
   archetype, then pulls REAL matching tiles from /collections/all-tiles?<filters>&view=quizdata
   (relaxing filters if a combo is too narrow) and shows recommendations + shop/sample CTAs. */
(function () {
  'use strict';
  var mount = document.querySelector('[data-quiz]');
  if (!mount) return;
  var spec;
  try { spec = JSON.parse(document.querySelector('[data-quiz-spec]').textContent); } catch (e) { return; }
  if (!spec || !spec.questions) return;

  var COLL = '/collections/all-tiles';
  var theme = window.theme || {};
  function money(cents) {
    var v = (parseFloat(cents) || 0) / 100;
    var f = (theme.moneyFormat || '${{amount}}');
    return f.replace(/\{\{\s*amount\s*\}\}/, v.toFixed(2));
  }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

  var state = { step: -1, answers: {} }; // answers[qid] = [optionIndex,...]

  // ---- tile-shape outline (reused idea from range swatches) for shape options ----
  function shapeSVG(size) {
    var s = String(size || ''), n = s.match(/\d+(?:\.\d+)?/g);
    function svg(inner) { return "<svg viewBox='0 0 44 44' width='38' height='38' fill='none' stroke='currentColor' stroke-width='1.6' stroke-linejoin='round' stroke-linecap='round'>" + inner + "</svg>"; }
    if (/diameter/i.test(s)) return svg("<circle cx='22' cy='22' r='16'/>");
    if (/crazy/i.test(s)) return svg("<polygon points='6,10 18,7 22,16 14,22 6,19'/><polygon points='22,16 18,7 31,8 37,15 30,21'/><polygon points='6,19 14,22 15,32 8,38 6,30'/><polygon points='14,22 30,21 32,30 22,38 15,32'/>");
    if (!n || n.length < 2) return svg("<rect x='6' y='6' width='32' height='32' rx='2'/>");
    var a = +n[0], b = +n[1], lo = Math.min(a, b), hi = Math.max(a, b), r = hi / lo;
    if (r < 1.25) return svg("<rect x='6' y='6' width='32' height='32' rx='2'/>");
    if (r >= 4 && lo <= 50) { var o = ''; for (var i = 0; i < 4; i++) { o += "<rect x='" + (8.5 + i * 7.2) + "' y='5' width='5' height='34' rx='2'/>"; } return svg(o); }
    var w = 34, h = Math.max(6, 34 * (lo / hi)); return svg("<rect x='" + (22 - w / 2) + "' y='" + (22 - h / 2) + "' width='" + w + "' height='" + h.toFixed(1) + "' rx='3'/>");
  }


  // ---- Outline room illustrations (64x64, stroke only) ----
  var ICONS = {
    bathroom: "<path d='M8 36h48v6a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8z'/><path d='M8 36V14a5 5 0 0 1 10 0v2'/><path d='M13 20h10'/><path d='M18 50v6M46 50v6'/><path d='M46 10a7 7 0 0 1 7 7H39a7 7 0 0 1 7-7z'/><path d='M42 22v3M46 22v4M50 22v3'/>",
    kitchen: "<path d='M14 20h36l-5-9H19z'/><path d='M8 40h48'/><rect x='8' y='40' width='48' height='14'/><path d='M32 40v14M14 47h4M46 47h4'/><path d='M22 32h20'/><path d='M27 32v-4h10v4'/><path d='M32 20v6'/>",
    splashback: "<rect x='8' y='8' width='48' height='30' rx='1'/><path d='M8 18h48M8 28h48'/><path d='M20 8v10M32 8v10M44 8v10M14 18v10M26 18v10M38 18v10M50 18v10M20 28v10M32 28v10M44 28v10'/><path d='M8 46h48'/><path d='M22 42h20'/><path d='M27 42v-3h10v3'/>",
    floor: "<path d='M8 56L20 16h24l12 40z'/><path d='M14 36h36M11 46h42M17 26h30'/><path d='M27 16l-6 40M37 16l6 40M32 16v40'/>",
    featurewall: "<rect x='8' y='8' width='48' height='34'/><path d='M8 25h48'/><path d='M16 8v17M24 8v17M32 8v17M40 8v17M48 8v17M12 25v17M20 25v17M28 25v17M36 25v17M44 25v17M52 25v17'/><path d='M4 42h56'/><path d='M40 42v6h8v-6'/><path d='M44 48v8'/><path d='M40 56h8'/>",
    outdoor: "<circle cx='48' cy='16' r='6'/><path d='M48 4v3M48 25v3M36 16h3M57 16h3M39.5 7.5l2 2M54.5 22.5l2 2M56.5 7.5l-2 2'/><path d='M6 40h30l-8-14H14z'/><path d='M14 26v14M28 26v14'/><path d='M4 56h56'/><path d='M4 48h56M12 48v8M24 48v8M36 48v8M48 48v8'/><path d='M40 40c2-6 8-6 10 0'/>"
  };
  function iconSVG(key) {
    var inner = ICONS[key]; if (!inner) return '';
    return "<svg class='quiz-opt__icon' viewBox='0 0 64 64' width='60' height='60' fill='none' stroke='currentColor' stroke-width='1.7' stroke-linejoin='round' stroke-linecap='round' aria-hidden='true'>" + inner + "</svg>";
  }

  function optionVisual(kind, opt) {
    if (opt.img) return "<span class='quiz-opt__photo' style='background-image:url(" + esc(opt.img) + ")'></span>";
    if (opt.icon) return iconSVG(opt.icon);
    if (opt.swatch) return "<span class='quiz-opt__swatch' style='background:" + esc(opt.swatch) + (/fff|f1|f6|f7|white|#e|#f/i.test(opt.swatch) ? ';box-shadow:inset 0 0 0 1px rgba(0,0,0,.15)' : '') + "'></span>";
    if (opt.shape) return "<span class='quiz-opt__shape'>" + shapeSVG(opt.shape) + "</span>";
    if (opt.emoji) return "<span class='quiz-opt__emoji'>" + esc(opt.emoji) + "</span>";
    return '';
  }

  function h(html) { mount.innerHTML = html; mount.scrollIntoView({ behavior: 'smooth', block: 'start' }); }

  // ---------- screens ----------
  function renderIntro() {
    var i = spec.intro;
    h("<div class='quiz-card quiz-intro'>" +
      "<span class='quiz-eyebrow'>" + esc(i.eyebrow) + "</span>" +
      "<h2 class='quiz-intro__title'>" + esc(i.title) + "</h2>" +
      "<p class='quiz-intro__sub'>" + esc(i.subtitle) + "</p>" +
      "<button class='btn btn--primary quiz-start' type='button'>" + esc(i.cta) + "</button>" +
      "<p class='quiz-note'>" + esc(i.note) + "</p></div>");
    mount.querySelector('.quiz-start').addEventListener('click', function () { state.step = 0; renderStep(); });
  }

  function renderStep() {
    var q = spec.questions[state.step];
    var total = spec.questions.length, pct = Math.round((state.step) / total * 100);
    var sel = state.answers[q.id] || [];
    var opts = q.options.map(function (opt, idx) {
      var on = sel.indexOf(idx) >= 0;
      return "<button type='button' class='quiz-opt" + (opt.img ? ' quiz-opt--photo' : '') + (opt.icon ? ' quiz-opt--icon' : '') + (on ? ' is-on' : '') + "' data-idx='" + idx + "'>" +
        "<span class='quiz-opt__vis'>" + optionVisual(q.kind, opt) + "</span>" +
        "<span class='quiz-opt__label'>" + esc(opt.label) + "</span>" +
        (opt.sub ? "<span class='quiz-opt__sub'>" + esc(opt.sub) + "</span>" : '') +
        "<span class='quiz-opt__tick' aria-hidden='true'>✓</span></button>";
    }).join('');
    h("<div class='quiz-card'>" +
      "<div class='quiz-progress'><span style='width:" + pct + "%'></span></div>" +
      "<div class='quiz-step-head'><span class='quiz-count'>Question " + (state.step + 1) + " of " + total + "</span>" +
      "<h2 class='quiz-q'>" + esc(q.title) + "</h2>" + (q.subtitle ? "<p class='quiz-q__sub'>" + esc(q.subtitle) + "</p>" : '') + "</div>" +
      "<div class='quiz-opts quiz-opts--" + esc(q.kind) + "'>" + opts + "</div>" +
      "<div class='quiz-nav'>" +
      (state.step > 0 ? "<button type='button' class='quiz-back'>&larr; Back</button>" : "<span></span>") +
      "<button type='button' class='btn btn--primary quiz-next'" + (sel.length ? "" : " disabled") + ">" +
      (state.step === total - 1 ? "See my tiles" : "Next") + "</button></div></div>");

    mount.querySelectorAll('.quiz-opt').forEach(function (b) {
      b.addEventListener('click', function () {
        var idx = +b.getAttribute('data-idx'); var cur = state.answers[q.id] || [];
        if (q.multi) { var p = cur.indexOf(idx); if (p >= 0) cur.splice(p, 1); else cur.push(idx); }
        else { cur = [idx]; }
        state.answers[q.id] = cur;
        if (!q.multi) { setTimeout(next, 160); } else { renderStep(); }
      });
    });
    var nb = mount.querySelector('.quiz-next'); if (nb) nb.addEventListener('click', next);
    var bb = mount.querySelector('.quiz-back'); if (bb) bb.addEventListener('click', function () { state.step--; renderStep(); });
  }

  function next() {
    var q = spec.questions[state.step];
    if (!(state.answers[q.id] || []).length) return;
    if (state.step < spec.questions.length - 1) { state.step++; renderStep(); }
    else finish();
  }

  // ---------- scoring + recommendation ----------
  function chosenOptions() {
    var list = [];
    spec.questions.forEach(function (q) { (state.answers[q.id] || []).forEach(function (i) { if (q.options[i]) list.push(q.options[i]); }); });
    return list;
  }
  function topArchetype(opts) {
    var w = {};
    opts.forEach(function (o) { (o.weights || []).forEach(function (x) { w[x.key] = (w[x.key] || 0) + x.w; }); });
    var best = null, bestW = -1;
    (spec.archetypes || []).forEach(function (a) { var s = w[a.key] || 0; if (s > bestW) { bestW = s; best = a; } });
    return best || (spec.archetypes || [])[0];
  }
  function buildFilters(opts, arche) {
    var f = {}; // param -> [values]
    opts.forEach(function (o) { if (o.filterParam && o.filterValue) { (f[o.filterParam] = f[o.filterParam] || []); if (f[o.filterParam].indexOf(o.filterValue) < 0) f[o.filterParam].push(o.filterValue); } });
    if (arche) (arche.filters || []).forEach(function (x) { if (!f[x.param]) f[x.param] = [x.value]; }); // archetype fills gaps only
    return f;
  }
  function query(f) {
    var parts = [];
    Object.keys(f).forEach(function (p) { f[p].forEach(function (v) { parts.push(p + '=' + v); }); });
    return parts.join('&');
  }
  function fetchCount(f) {
    var q = query(f);
    return fetch(COLL + '?' + q + (q ? '&' : '') + 'view=quizdata').then(function (r) { return r.json(); }).catch(function () { return { count: 0, items: [] }; });
  }
  var DROP = ['filter.p.m.custom.finish', 'filter.p.m.custom.shape', 'filter.p.m.custom.look', 'filter.p.m.custom.area', 'filter.p.m.custom.colour'];
  async function recommend(f) {
    var applied = JSON.parse(JSON.stringify(f));
    var data = await fetchCount(applied);
    var di = 0;
    while ((data.count || 0) < 4 && Object.keys(applied).length > 1 && di < DROP.length) {
      if (applied[DROP[di]]) { delete applied[DROP[di]]; data = await fetchCount(applied); }
      di++;
    }
    if ((data.count || 0) < 1) { applied = {}; data = await fetchCount(applied); }
    return { data: data, applied: applied };
  }

  function tileCard(p) {
    var m2 = parseFloat(p.m2) || 0, m2b = parseFloat(p.m2b) || 0;
    var priceHtml = m2 > 0
      ? "<span class='quiz-rec__m2'>" + money(m2 * 100) + "<span class='quiz-rec__unit'>/m²</span></span><span class='quiz-rec__box'>" + money(p.price) + " per box</span>"
      : "<span class='quiz-rec__m2'>" + money(p.price) + "</span>";
    return "<a class='quiz-rec' href='" + esc(p.u) + "'>" +
      "<span class='quiz-rec__img'" + (p.img ? " style='background-image:url(" + esc(p.img) + ")'" : "") + "></span>" +
      "<span class='quiz-rec__body'><span class='quiz-rec__title'>" + esc(p.t) + "</span>" + priceHtml + "</span></a>";
  }

  async function finish() {
    h("<div class='quiz-card quiz-loading'><div class='quiz-spinner'></div><p>Matching you with the perfect tiles…</p></div>");
    var opts = chosenOptions();
    var arche = topArchetype(opts);
    var f = buildFilters(opts, arche);
    var rec = await recommend(f);
    var items = (rec.data.items || []).slice(0, 6);
    var count = rec.data.count || items.length;
    var shopUrl = COLL + (query(rec.applied) ? '?' + query(rec.applied) : '');
    var res = spec.result || {};
    var cards = items.length ? items.map(tileCard).join('') : "<p class='quiz-empty'>Explore the full range to find your match.</p>";
    h("<div class='quiz-card quiz-result'>" +
      "<span class='quiz-eyebrow'>Your tile style</span>" +
      "<h1 class='quiz-result__name'>" + esc(arche.name) + "</h1>" +
      (arche.tagline ? "<p class='quiz-result__tagline'>" + esc(arche.tagline) + "</p>" : '') +
      "<p class='quiz-result__desc'>" + esc(arche.description) + "</p>" +
      "<div class='quiz-result__actions'>" +
      "<a class='btn btn--primary' href='" + esc(shopUrl) + "'>" + esc(res.shopCta || 'Shop your matches') + (count ? " (" + count + ")" : "") + "</a>" +
      "<a class='btn btn--ghost' href='" + COLL + "'>" + esc(res.sampleCta || 'Order 5 samples for $15') + "</a></div>" +
      "<h3 class='quiz-rec__h'>" + esc(res.recommendTitle || 'Recommended for you') + "</h3>" +
      "<div class='quiz-recs'>" + cards + "</div>" +
      "<button type='button' class='quiz-retake'>↻ Retake the quiz</button></div>");
    var rt = mount.querySelector('.quiz-retake'); if (rt) rt.addEventListener('click', function () { state = { step: -1, answers: {} }; renderIntro(); });
  }

  renderIntro();
})();
